import { z } from 'zod';

import { isoDatetimeToDate } from './dates';

// Shape returned by `GET /api/v2/promos/active` (already filtered to the
// records this user is eligible to see and has not dismissed). Response
// keys are camelCased by the `Key-Inflection: camel` header on the request.
export const ActivePromo = z.object({
	id: z.string(),
	name: z.string(),
	title: z.string(),
	body: z.string(),
	imageUrl: z.string().nullable().optional(),
	// Set by the backend based on the uploaded file's extension. Drives
	// whether the FE renders an <img> or a <video>.
	mediaType: z.enum(['image', 'video']).nullable().optional(),
	// Optional call-to-action label. When blank or absent, promo surfaces fall
	// back to their localized "Learn more" string.
	ctaLabel: z.string().nullable().optional(),
	// Optional call-to-action URL. When present, the floating tile shows
	// a call-to-action link that opens this URL in a new tab; when absent,
	// the tile renders headline + body only and dismissal happens via the
	// X button.
	ctaUrl: z.string().nullable().optional(),
	startsAt: isoDatetimeToDate,
	endsAt: isoDatetimeToDate,
});

export type ActivePromo = z.infer<typeof ActivePromo>;
